import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactPlayer from 'react-player';
import { useMedia } from 'react-use';
import { getSanityImg } from 'src/sanityClient';
import layout from 'ck-utils/layout.module.scss';
import { getPromoName, trackPromotionClick } from '../utils';
import { usePromotionView } from '../hooks';
import styles from './FeatureContainer.module.scss';

const FeatureContainer = ({
  blockNavigation,
  children,
  handle,
  position,
}) => {
  const { hasBackgroundImg, title, description, video, videoMobile, videoThumbnail, trackingID } = blockNavigation;
  const isMobile = useMedia('(max-width: 767px)');
  const ref = React.useRef(null);
  const videoUrl = isMobile && videoMobile ? videoMobile : video;
  const videoThumbnailUrl = getSanityImg(videoThumbnail).auto('format').url();
  const promo = {
    id: handle,
    name: getPromoName(handle, trackingID || title || videoUrl),
    creative: videoThumbnailUrl,
    position: `${handle}-${position}`
  };
  usePromotionView([promo], ref);
  return (
    <div
      ref={ref}
      className={classnames(
        'container',
        styles.headerContainer,
        { [styles.headerContainerBackground]: hasBackgroundImg }
      )}
    >
      <div className={styles.title}>{title}</div>
      <div className={styles.titleDescriptionContainer}>
        <div className={styles.titleDescription}>{description}</div>
      </div>
      {video && (
        <div className={classnames(styles.video, layout.marginTopLarge)}>
          <ReactPlayer
            controls
            playing
            className={styles.player}
            width="100%"
            height="100%"
            url={videoUrl}
            light={videoThumbnailUrl || true}
            onPlay={() => trackPromotionClick(promo)}
          />
        </div>
      )}
      {children}
    </div>
  );
};

FeatureContainer.propTypes = {
  children: PropTypes.object,
  blockNavigation: PropTypes.object.isRequired,
  handle: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
};

FeatureContainer.defaultProps = {
  children: null,
};

export { FeatureContainer };
